<div class="mt">
  <p class="text">50.{{ Texts.title }}</p>
  <div class="row">
    <ng-container [formGroup]="instrumentForm">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.instrumentType }}</mat-label>
          <mat-select
            formControlName="instrumentType"
            (selectionChange)="instrumentChange()"
          >
            <mat-option
              *ngFor="let instrumentType of instrumentsT"
              [value]="instrumentType"
            >
              {{ instrumentType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label
            >{{ Texts.instrumentNumber }}
            <span *ngIf="requireds">*</span></mat-label
          >
          <input type="text" matInput formControlName="instrumentNumber" />
        </mat-form-field>
      </div>
      <!-- <div class="col-4">
        <mat-form-field
          (click)="addFile()"
          class="informe"
          appearance="outline"
        >
          <mat-label
            >{{ Texts.file }} <span *ngIf="requireds">*</span></mat-label
          >
          <input
            class="informe"
            disabled
            matInput
            [value]="file ? file : Texts.file"
          />
        </mat-form-field>
      </div> -->
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label
            >{{ Texts.agency }} <span *ngIf="requireds">*</span></mat-label
          >
          <input type="text" matInput formControlName="agency" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label
            >{{ Texts.openingDate }} <span *ngIf="requireds">*</span></mat-label
          >
          <input type="date" matInput formControlName="openingDate" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.deadline }} </mat-label>
          <input type="date" matInput formControlName="deadline" />
        </mat-form-field>
      </div>

      <div class="col-12 buttons">
        <button
          *ngIf="editing == null"
          [disabled]="instrumentForm.invalid"
          class="primary-btn rounded"
          mat-raised-button
          (click)="add()"
        >
          Agregar
        </button>
        <ng-container *ngIf="editing != null">
          <button
            class="cancel-btn rounded"
            mat-raised-button
            (click)="cancelEdit()"
          >
            Cancelar
          </button>
          <button
            class="primary-btn rounded"
            mat-raised-button
            [disabled]="instrumentForm.invalid"
            (click)="edit()"
          >
            Editar
          </button>
        </ng-container>
      </div>
    </ng-container>
    <div class="col-12">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="instrumentType">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.instrumentType }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.instrumentType }}
          </td>
        </ng-container>
        <ng-container matColumnDef="instrumentNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.instrumentNumber }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.instrumentNumber }}
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="file">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.file }}
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ element.file.name
            }}<span
              ><mat-icon class="downloadIcon informe" (click)="download(i)"
                >file_download</mat-icon
              ></span
            >
          </td>
        </ng-container> -->
        <ng-container matColumnDef="agency">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.agency }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.agency }}</td>
        </ng-container>
        <ng-container matColumnDef="openingDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.openingDate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.openingDate }}</td>
        </ng-container>
        <ng-container matColumnDef="deadline">
          <th mat-header-cell *matHeaderCellDef>
            {{ Texts.deadline }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.deadline }}</td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef>Opciones</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <div class="options">
              <mat-icon class="edit" (click)="setToEdit(i)">edit</mat-icon>
              <mat-icon class="delete" (click)="delete(i)">delete</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
